import { rotaDeFabricacao } from "@/views/Materiais";
import { carregarControleAcessoAdicionarUsuario } from "@/views/ControleAcesso";
import { creFabricaRotas } from "@/views/CREFabrica";
const rotas = [
  {
    path: "/fabricacao/:obra",
    layoutNome: "LayoutFabricacao",
    component: () => import("@/layout/LayoutFabricacao.vue"),
    meta: {
      icon: "mdi-mdi-account",
      subject: [],
      showMenu: false,
    },
    children: [
      {
        path: "",
        name: "Fabricação",
        component: () => import("@/views/Fabricacao/DashboardFabricacao.vue"),
        meta: {
          breadcrumb: "Todas as Fabricações",
          title: "Fabricação",
          icon: "mdi-view-dashboard-outline",
          showMenu: false,
          subject: ["FABRICACAO", "PROJETO_FABRICA"],
        },
      },
      {
        path: "usuarios/adicionar",
        name: "Adicionar Usuários",
        component: carregarControleAcessoAdicionarUsuario,
        meta: {
          breadcrumb: "Todas as Fabricações|Fabricação",
          obraObrigatoria: true,
          title: "Adicionar Usuários",
          icon: "mdi-account-multiple-plus-outline",
          action: ["adicionar_cliente"],
          subject: ["PROJETO_FABRICA", "FABRICACAO"],
          showMenu: true,
        },
      },
      {
        path: "/fabricacao/nova",
        name: "Nova Fabricação",
        component: () => import("@/views/Fabricacao/NovoProdutoServico.vue"),
        meta: {
          breadcrumb: "Todas as Fabricações",
          icon: "mdi-toy-brick-plus-outline",
          title: "Nova Fabricação",
          acessoRapido: false,
          showMenu: true,
          subject: ["FABRICACAO"],
          action: ["write"],
        },
      },
      {
        path: "/fabricacao/:obra/atualizar",
        name: "Atualizar Fabricação",
        component: () => import("@/views/Fabricacao/UpdateProdutoServico.vue"),
        meta: {
          breadcrumb: "Todas as Fabricações|Fabricação",
          title: "Atualizar Fabricação",
          icon: "mdi-pencil",
          acessoRapido: false,
          showMenu: true,
          subject: ["FABRICACAO"],
          action: ["update"],
        },
      },
      ...creFabricaRotas.obra,
      {
        path: "/produto/taf/:obra",
        name: "TAF Produto",
        component: () => import("@/views/Produto/DashboardTafProduto.vue"),
        meta: {
          breadcrumb: "",
          title: "TAF Produto",
          icon: "mdi-text-box-multiple-outline",
          subject: ["TAF"],
          showMenu: true,
          grupo: "Produto",
          grupoTitle: "Produto",
        },
      },
      ...rotaDeFabricacao,
    ],
  },
  {
    path: "",
    layoutNome: "LayoutGeral",
    component: () => import("@/layout/LayoutGeral.vue"),
    meta: {
      showMenu: false,
    },
    children: [
      {
        path: "/fabricacao/nova",
        name: "Nova Fabricação",
        component: () => import("@/views/Fabricacao/NovoProdutoServico.vue"),
        meta: {
          icon: "mdi-toy-brick-plus-outline",
          title: "Nova Fabricação",
          breadcrumb: "Todas as Fabricações",
          acessoRapido: false,
          showMenu: true,
          grupo: "FABRICACAO",
          grupoTitle: "Fabricação",
          subject: ["FABRICACAO"],
          action: ["write"],
        },
      },
      {
        path: "/fabricacao",
        name: "Todas as Fabricações",
        component: () => import("@/views/Fabricacao/TodasFabricacoes.vue"),
        meta: {
          title: "Todas as Fabricações",
          icon: "mdi-toy-brick-search-outline",
          acessoRapido: false,
          showMenu: true,
          subject: ["FABRICACAO"],
        },
      },
      {
        path: "",
        name: "Fabricação Home",
        component: () => import("@/views/Fabricacao/FabricacoesHome.vue"),
        meta: {
          breadcrumb: "",
          title: "Fabricação Home",
          icon: "mdi-view-dashboard-outline",
          showMenu: false,
          subject: ["FABRICACAO", "PROJETO_FABRICA"],
        },
      },
      ...creFabricaRotas.geral,
    ],
  },
];

export default rotas;
